import { render } from "./advance-applay.vue?vue&type=template&id=3de0daa8&scoped=true&ts=true"
import script from "./advance-applay.vue?vue&type=script&lang=ts"
export * from "./advance-applay.vue?vue&type=script&lang=ts"

import "./advance-applay.vue?vue&type=style&index=0&id=3de0daa8&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de0daa8"]])

export default __exports__